import { render, staticRenderFns } from "./AssetSnippet.vue?vue&type=template&id=5cd01005&scoped=true&"
import script from "./AssetSnippet.vue?vue&type=script&lang=js&"
export * from "./AssetSnippet.vue?vue&type=script&lang=js&"
import style0 from "./AssetSnippet.vue?vue&type=style&index=0&id=5cd01005&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd01005",
  null
  
)

export default component.exports